/**
 * Canonical product URLs for the Prometheus MCP connector.
 *
 * The connector is the product — the account surface, the landing page,
 * and the docs all need to point users at the same endpoint and at
 * Claude's connector settings. Keeping these here stops the URL from
 * drifting across surfaces.
 */

export const CONNECTOR_URL =
  'https://mcp.prometheuslaw.app/functions/v1/prometheus-connector';

export const CLAUDE_INTEGRATIONS_URL = 'https://claude.ai/settings/integrations';
